import React from 'react';
import { motion } from 'framer-motion';
import useScrollReveal from '../hooks/useScrollReveal';

const About = () => {
  const { ref, inView } = useScrollReveal({ threshold: 0.15 });

  return (
    <section id="about" className="section-padding bg-[var(--bg-secondary)]">
      <div className="container-tight">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 40 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, ease: 'easeOut' }}
        >
          <h2 className="section-heading accent-underline inline-block mb-12">
            About Me
          </h2>

          <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-center">
            {/* Profile image */}
            <div className="flex-shrink-0">
              <div className="relative w-56 h-56 md:w-64 md:h-64 rounded-2xl overflow-hidden ring-4 ring-[var(--bg-primary)] shadow-xl">
                <img
                  src="https://s3.pelindo.co.id/genc/ptosm/CfE3OjlQ761oDT7CgVIKrAYFPEKfzsLZVvMijdzy.jpeg"
                  alt="Muhammad Inal Zaelani"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 ring-1 ring-inset ring-[var(--border)] rounded-2xl pointer-events-none" />
              </div>
            </div>

            {/* Text */}
            <div className="flex-1 space-y-5">
              <h3 className="text-2xl md:text-3xl font-bold text-[var(--text-primary)] tracking-tight">
                Full Stack Developer based in Surabaya, Indonesia
              </h3>

              <p className="text-[var(--text-secondary)] leading-relaxed">
                Experienced full stack developer specializing in creating innovative,
                high-performance web and mobile applications. Expertise spans React,
                Vue.js, Spring Boot, and Golang — with a solution-oriented approach
                focused on clean, efficient, and maintainable code.
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-2">
                {[
                  { label: 'Name', value: 'Muhammad Inal Zaelani' },
                  { label: 'Email', value: 'inalzaelani2806@gmail.com' },
                  { label: 'Location', value: 'Surabaya, Indonesia' },
                  { label: 'Status', value: 'Available for Projects' },
                ].map((d) => (
                  <div key={d.label} className="flex gap-2 text-sm">
                    <span className="font-semibold text-[var(--text-primary)] whitespace-nowrap">
                      {d.label}:
                    </span>
                    <span className="text-[var(--text-secondary)]">{d.value}</span>
                  </div>
                ))}
              </div>

              <a
                href="#contact"
                className="inline-block mt-2 px-6 py-3 bg-accent text-white font-semibold rounded-full hover:bg-accent-hover transition-colors duration-300 shadow-lg shadow-accent/25"
              >
                Contact Me
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
